import { 
  AlertDialog, 
  AlertDialogContent, 
  AlertDialogDescription, 
  AlertDialogFooter, 
  AlertDialogHeader, 
  AlertDialogTitle 
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, Info } from "lucide-react";
import { JobHubJob } from "@/lib/jobUtils";

interface ActivateJobModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  job: JobHubJob | null;
  onConfirm: () => void;
}

export function ActivateJobModal({ open, onOpenChange, job, onConfirm }: ActivateJobModalProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-[425px]" data-testid="activate-job-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xl font-bold text-gray-900">
            Activate Job Listing
          </AlertDialogTitle>
          <AlertDialogDescription className="text-gray-600">
            Are you sure you want to activate "<span className="font-medium text-gray-900">{job?.title}</span>"? This action will:
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        <div className="py-4">
          <div className="space-y-3">
            <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-200 rounded-lg">
              <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
              <div className="text-sm">
                <p className="font-medium text-green-800 mb-1">
                  Publish the job listing
                </p>
                <p className="text-green-700">
                  Users will be able to view and refer candidates to this position.
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
              <Info className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
              <div className="text-sm">
                <p className="font-medium text-blue-800 mb-1">
                  Resume recruitment activities
                </p>
                <p className="text-blue-700">
                  The job will appear in public listings and referral opportunities will be available again.
                </p>
              </div>
            </div>
          </div>
        </div>

        <AlertDialogFooter>
          <Button 
            variant="secondary"
            size="sm"
            onClick={() => onOpenChange(false)}
            data-testid="cancel-activate-job"
          >
            Cancel
          </Button>
          <Button 
            variant="primary"
            size="sm"
            onClick={onConfirm}
            data-testid="confirm-activate-job"
          >
            Activate Job
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
